const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contact service",
  description: "Welcome to contact service",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Rengaskauppatiimi",
    car: "Autoliiketiimi",
    lkw: "Kuorma-autotiimi",
    em_otr: "EM/OTR-tiimi",
    farm_tractor: "Maataloustraktoritiimi",
    bandag: "Bandag-tiimi",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
